import styled from 'styled-components'
import { Box } from 'src/components'
import { Link } from 'react-router-dom'

export const OverSection = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: start;
    text-align: start;
`
export const TypographyContent = styled(Link)`
    text-align: start;
`
